import React, { useState, useEffect, useCallback } from "react";
import { ordersData } from "../../Datas/OrdersData";
import './AllOrdersTable.css';
import OrderTrackingModal from '../OrderTrackingModal/OrderTrackingModal';  // Import the modal component

const AllOrdersTable = () => {
  const [modalData, setModalData] = useState(null);
  const [filteredOrders, setFilteredOrders] = useState(ordersData);
  const [searchTerm, setSearchTerm] = useState("");
  const [isTrackingModalOpen, setIsTrackingModalOpen] = useState(false); // State to handle tracking modal visibility
  const [currentOrder, setCurrentOrder] = useState(null); // State to store the current order data for tracking modal

  const sortOrdersByDate = () => {
    return ordersData.sort((a, b) => {
      const dateA = new Date(a.bookingDate);
      const dateB = new Date(b.bookingDate);
      return dateB - dateA;
    });
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filterOrders = useCallback(() => {
    const sortedOrders = sortOrdersByDate();
    return sortedOrders.filter(order =>
      order.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  const openModal = (invoiceUrl) => {
    setModalData(invoiceUrl);
  };

  const closeModal = () => {
    setModalData(null);
    setIsTrackingModalOpen(false); // Close the tracking modal when closing invoice modal
  };

  const openTrackingModal = (order) => {
    setCurrentOrder(order);  // Set the selected order
    setIsTrackingModalOpen(true);  // Open the tracking modal
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "Out for Delivery":
        return "status-out-for-delivery";
      case "Delivered":
        return "status-delivered";
      case "Packaging":
        return "status-on-hold";
      case "Shipped":
        return "status-shipped";
      default:
        return "";
    }
  };

  useEffect(() => {
    setFilteredOrders(filterOrders());
  }, [filterOrders]);

  return (
    <div className="all-orders-container">
      <input
        type="text"
        className="search-barallorders"
        placeholder="Search by Name..."
        value={searchTerm}
        onChange={handleSearch}
      />

      <table className="orders-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Vendor</th>
            <th>Booking Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders.map((order) => (
            <tr key={order.id}>
              <td>{order.name}</td>
              <td>{order.vendorName}</td>
              <td>{order.bookingDate}</td>
              <td className={getStatusClass(order.status)}>{order.status}</td>
              <td>
                <button
                  className="details-button"
                  onClick={() => openModal(order.invoice)}
                >
                  Details
                </button>
                <button
                  className="Track-button"
                  onClick={() => openTrackingModal(order)} // Open tracking modal on button click
                >
                  Track
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {modalData && (
        <div className="modal-overlay">
          <div className="modal-content-invoice">
            <button className="close-button" onClick={closeModal}>
              &times;
            </button>
            <h3>Invoice</h3>
            <img src={modalData} alt="Invoice" />
          </div>
        </div>
      )}

      {/* Conditionally render the tracking modal if it is open */}
      {isTrackingModalOpen && currentOrder && (
        <OrderTrackingModal
          order={currentOrder}  // Pass the current order data to the modal
          onClose={closeModal}  // Close the modal on button click
        />
      )}
    </div>
  );
};

export default AllOrdersTable;
